export default __webpack_public_path__ + "static/invitationVideo-9acb733b689e31cd6822dc69bb8a9352.mp4";